var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLowerPriorityGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.021,
    height: 10.468,
    viewBox: "0 0 21.021 10.468",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7390",
    "data-name": "Group 7390",
    transform: "translate(-472.479 -2149.267)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "right-arrow_1_",
    "data-name": "right-arrow (1)",
    transform: "translate(522.367 2149.517) rotate(90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7215",
    "data-name": "Group 7215",
    transform: "translate(0 41.346)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4969",
    "data-name": "Path 4969",
    d: "M9.809,45.105l-3.6-3.6a.547.547,0,0,0-.772,0l-.327.327a.541.541,0,0,0-.159.386.552.552,0,0,0,.159.39l2.1,2.1H.539A.532.532,0,0,0,0,45.249v.462a.553.553,0,0,0,.539.56h6.7L5.111,48.388a.54.54,0,0,0,0,.766l.327.326a.547.547,0,0,0,.772,0l3.6-3.6a.55.55,0,0,0,0-.774Z",
    transform: "translate(0 -41.346)",
    fill: "#a6acb5",
    stroke: "#a6acb5",
    strokeWidth: 0.5
  }))), /*#__PURE__*/React.createElement("line", {
    id: "Line_1024",
    "data-name": "Line 1024",
    x2: 8,
    transform: "translate(484.5 2150.5)",
    fill: "none",
    stroke: "#a6acb5",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1026",
    "data-name": "Line 1026",
    x2: 8,
    transform: "translate(484.5 2154.5)",
    fill: "none",
    stroke: "#a6acb5",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1028",
    "data-name": "Line 1028",
    x2: 8,
    transform: "translate(484.5 2158.5)",
    fill: "none",
    stroke: "#a6acb5",
    strokeLinecap: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowerPriorityGray);
export default __webpack_public_path__ + "static/media/lower-priority-gray.522c5cc7999ed8b0385bb3e3a7449652.svg";
export { ForwardRef as ReactComponent };